import { Spine } from "@esotericsoftware/spine-pixi-v8";
import { DisplayObject, IDisplayObject } from "../../core/displays/DisplayObject";

export class Transition extends DisplayObject {
    private introTransition: Spine;

    constructor(config: IDisplayObject) {
        super(config);

        this.introTransition = Spine.from({
            skeleton: "bannerTransitionSkel",
            atlas: "bannerTransitionAtlas"
        });

        this.introTransition.label = "introTransition";
        this.addChild(this.introTransition);
    }

    public play(): void {
        this.introTransition.state.setAnimation(0, "animation", false);
    }
}